import React from "react";
import {ControlLabel, FormControl, Button, Alert} from "react-bootstrap";
import {browserHistory} from "react-router";
import context from "./../../lib/context.js";
import moment from "moment";

export default class CreateTCForm extends React.Component {

    constructor(props){
        super(props);
        this.shouldEnableCreateTcButton = this.shouldEnableCreateTcButton.bind(this);
        this.onFieldChange = this.onFieldChange.bind(this);
        this.inputs = {};
    }

    onFieldChange(fieldName, value, callback) {
        var patch = (fieldName === "placement")? // format: <PlacementID_OffsysID_PeopleID>
            {
                placementId: value.split('_')[0],
                offsysId: value.split('_')[1],
                employeeId: value.split('_')[2]
            } 
        :
            {
                [fieldName] : value
            };

        this.props.onFieldChange({createTc: patch}, callback);
    }

    createTimecard(callback) {
        const self = this;
        let vm = this.props.vm;
        let selectedEmp = vm.peopleList.find((p) => p.placementId == vm.placementId && p.offsysId == vm.offsysId);

        var patch = {
            reason : self.inputs.reason.value.trim(),
            employee : selectedEmp? selectedEmp.fullName: null
        };    
        this.props.onFieldChange({createTc: patch}, callback);
    }

    shouldEnableCreateTcButton() {
        let vm = this.props.vm;
        if (vm == null) return false;

        return (vm.placementId != null && vm.placementId.trim().length > 0) &&
               (vm.reason != null && vm.reason.trim().length > 0) &&
               (vm.selectedWeekEnding != null && vm.selectedWeekEnding.length > 0)
    }

    render() {
        const self = this;
        let vm = this.props.vm;
        if (vm == null) {
            return (
                <div className="container">
                    <div className="row">
                        
                    </div>
                </div>
                );
        }
        let weekEndings = vm.weekEndings;
        let current = moment().endOf("week");
        let options = weekEndings.map(function(ending) {
            let m = moment(ending);            
            return (<option key={m.format("YYYY-MM-DD")} value={m.format("YYYY-MM-DD")}>{m.format("dddd, MMMM Do YYYY")}</option>)
            });

        let employees = vm.peopleList.map(function(p) {
            let placement = `${p.placementId}_${p.offsysId}_${p.peopleId}`;
            return (<option key={placement} value={placement}>{p.fullName}</option>)
            });

        let msgClass = "", msgStyle="info";

        if (vm.messageType === null) {
            msgClass = "ap-hidden";
        } else {
            msgStyle = vm.messageType;
        }

        let createTcButtonClass = "ap-fullsize" + (this.shouldEnableCreateTcButton() ? " btn-info" : "");
        vm.selectedWeekEnding = vm.selectedWeekEnding || "";
        return (            
            <div className="container">
                <div className="row">
                    <div className="col-md-12 ap-headline">
                        <div className="ap-text">Create New Timecard</div>
                        <hr />
                    </div>                                              
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <Alert bsStyle={msgStyle} className={msgClass}>
                            {vm.message}
                        </Alert>
                    </div>                        
                </div>
                <div className="row">
                    <div className="col-md-6">                            
                        <ControlLabel>Employee <span className="ap-color-red"> *</span></ControlLabel>
                        <FormControl componentClass="select"
                            onChange={(evt) => this.onFieldChange("placement", evt.target.value)}>
                            <option key="" value="">--Select an Employee--</option>
                            {employees}
                        </FormControl>
                    </div>                                              
                    <div className="col-md-6">
                        <ControlLabel>Week Ending Date <span className="ap-color-red"> *</span></ControlLabel>                                                    
                        <FormControl componentClass="select" value={vm.selectedWeekEnding}
                        onChange={(evt) => this.onFieldChange("selectedWeekEnding", evt.target.value)}>
                            <option key="" value="">--Select a Week Ending Date--</option>
                            {options}
                        </FormControl>     
                    </div>                                              
                </div>
                <div className="row">
                    <div className="col-md-12">                            
                        <ControlLabel>Reason <span className="ap-color-red"> *</span></ControlLabel>
                        <FormControl componentClass="textarea" placeholder="Reason" rows="4" 
                        defaultValue={vm.reason} inputRef={node => self.inputs.reason = node} />
                    </div>                                                                  
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <Button className={createTcButtonClass} className="btn-info ap-fullsize"
                        onClick={() => self.createTimecard(()=> self.props.onNewTimecard())}>Create New Timecard</Button>
                    </div>
                </div>
            </div>
            );
    }
}